import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import {
  Article,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { MediaItemCardWithActionsInnerChild } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActionsInnerChild";
import { MediaItemType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemType";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import React from "react";
import styles from "../../../styles/common-media-styles.module.css";

export interface MediaItemCardWithActionsProps<
  T extends Article | AggregatedArticle,
> {
  item: Item;
  badges?: ItemBadge[];
  saleStartDate?: string;
  edsData: EdsData | null;
  article: T;
  renderActions?: () => React.ReactNode;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  mediaItemType?: MediaItemType;
  itemCardRenderType?: ItemCardRenderType;
  mediaItemViewType?: MediaItemViewType;
  stockInfo?: ItemStockInfo;
  className?: string;
}

export const MediaItemCardWithActions = <
  T extends Article | AggregatedArticle,
>({
  item,
  edsData,
  badges,
  saleStartDate,
  article,
  renderActions,
  shouldDisplayQuantity = false,
  totalQuantityPieces,
  mediaItemType = MediaItemType.REGULAR_ITEM,
  itemCardRenderType = ItemCardRenderType.link,
  mediaItemViewType,
  stockInfo,
  className,
}: MediaItemCardWithActionsProps<T>) => {
  const navigationUrl =
    itemCardRenderType === ItemCardRenderType.link
      ? mediaItemViewType === MediaItemViewType.AGGREGATED_ITEM_VIEW
        ? `/mediamaintenance/medias/${article.mediaId}/articles/${article.id}/product_article_id/${article.productArticleId}?media-item-type=${mediaItemType}`
        : `/mediamaintenance/articles/${article.id}?media-item-type=${mediaItemType}`
      : undefined;

  return (
    <ItemCard
      className={className}
      badges={badges as ItemBadge[]}
      dataTestId="media-item-card-with-actions"
    >
      {itemCardRenderType === ItemCardRenderType.link ? (
        <FixaLink to={navigationUrl!} className={styles["item-card-root-row"]}>
          <MediaItemCardWithActionsInnerChild
            item={item}
            saleStartDate={saleStartDate}
            articleHfb={article.hfb}
            shouldDisplayQuantity={shouldDisplayQuantity}
            totalQuantityPieces={totalQuantityPieces || 0}
            edsData={edsData ?? null}
            stockInfo={stockInfo}
          />
        </FixaLink>
      ) : (
        <div className={styles["item-card-root-row"]}>
          <MediaItemCardWithActionsInnerChild
            itemCardRenderType={itemCardRenderType}
            item={item}
            saleStartDate={saleStartDate}
            articleHfb={article.hfb}
            shouldDisplayQuantity={shouldDisplayQuantity}
            totalQuantityPieces={totalQuantityPieces || 0}
            edsData={edsData ?? null}
            stockInfo={stockInfo}
          />
        </div>
      )}
      {renderActions && renderActions()}
    </ItemCard>
  );
};
